import React, { memo, useState } from 'react'
import { GTextareaCom, } from '../AllInput/AllInput'

import { SupportDTy } from '../AllInput/types'
import { useAppSelector } from '../../ReduxTool/store/hooks'
import ReactSelect from '../New/Select/ReactSelect'
import VInputUpload from '../Upload.tsx/VInputUpload'
import { AccountIcon, CallIcon, EditIcon, InfoMark, NewMailIcon, TaskSuccess, VerifiedIcon } from '../../assests/icons/Icons'
import { ProfileModalType } from '../../Containers/DefaultLayouts/DefaultHeader'
import { handlePreviewClick } from '../../Utils/commonFunctions'
import NewFileUpload from '../Upload.tsx/NewFileUpload'

interface SupportProps { isEditing?: boolean; profileState: SupportDTy; error: any; handleChange: (e: any, selectedOption?: any) => void; uploadedFiles?: any; uploadFileNames?: any; setUploadFileNames?: (files: any) => void; clearError?: (fieldName: string) => void; handleProfileEdit?: () => void; openViewProfileModal?: (modalName: ProfileModalType) => void; supportSuccess: { show: boolean; ticketCode: string }; }

const Support = ({ isEditing, profileState, error, handleChange, uploadedFiles, uploadFileNames, setUploadFileNames, clearError, handleProfileEdit, openViewProfileModal, supportSuccess }: SupportProps) => {
  const { supportSubjectList } = useAppSelector(state => state.commonReducers)
  const { user } = useAppSelector((state) => state.auth);
  const subjectLabel = profileState.subject?.label?.toLowerCase() || '';
  const isPan = subjectLabel.includes('pan upload for module');
  const isOnd = subjectLabel.includes('ond upload for inverter');
  const isUploadRequired = isPan || isOnd;

  const BoxUiUserDetails = () => {
    return (
      <div className="w-full rounded-xl border border-[#D9D9D9] bg-[#F4F4F5] px-4 py-2.5">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          {/* <span data-tooltip-id="userdetailstooltip"> <InfoMark />   </span> */}
          <p className="text-12-roboto flex gap-1 uppercase"> Contact details for this request  </p> 
          <button data-tooltip-id="userdetailstooltip" type="button" onClick={handleProfileEdit} className=" size-4 flex items-center justify-center" > <EditIcon /> </button>
        </div>

        {/* Content */}
        <div className="flex w-full text-sm text-gray-700 ">
          {/* User */}
          <div className="flex items-start gap-3 py-1.5 border-r flex-1 border-gray-400 max-w-[33%]">
            <span className="text-purple-600 pt-1"> <AccountIcon /> </span>
            <div className="flex flex-col leading-tight w-full min-w-0 gap-1 pr-2">
              <span className="text-14-inter-medium-info">User</span>
              {/* <span className="text-12-inter-normal-info  truncate"> {profileState.fname} {profileState.lname} </span> */}
              <span className="text-12-inter-normal-info  truncate"> {user.fname} {user.lname} </span>
            </div>
          </div>

          {/* Phone */}
          <div className="flex items-start gap-3 flex-1 py-1.5 border-r border-gray-400 pl-4 max-w-[33%]">
            <span className="text-pink-600 pt-1"><CallIcon />  </span>
            <div className="flex flex-col leading-tight w-full min-w-0 pr-2 gap-1">
              <span className="text-14-inter-medium-info">Phone Number</span>
              <span className="text-12-inter-normal-info truncate">{user.mobile}</span>
            </div>
          </div>

          {/* Email */}
          <div className="flex gap-3 flex-1 items-start py-1.5 pl-4 max-w-[33%] " >
            <span className="text-gray-500 pt-1"><NewMailIcon /></span>
            <div className="flex flex-col leading-tight w-full min-w-0 pr-2 gap-1">
              <span className="text-14-inter-medium-info flex justify-between">Email <VerifiedIcon /></span>
              <span className="text-12-inter-normal-info truncate">{user.emailid}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }


  const HeaderBox = () => {
    return (
      <>
        <div className='pt-2 pb-4'>
          <h2 className='heading-16-roboto-normal'>We’re here to help you at every step of our solar journey.</h2>
          <span className='text-12-roboto'>Average response time: within 24 working hours</span>
        </div>
      </>
    )
  }
  return (
    <>
      {/* ================= Success indicator ================= */}
      {supportSuccess?.show && (
        <div className="mb- animate-slideDown rounded-lg border text-sm text-gray-700 border-green-200 bg-green-50 px-4 py-3 ">
          <div className="flex flex-col gap-2">
            <div className='flex'>
              <span className='pt-1'><TaskSuccess /></span>
              <div className='flex flex-col items-start pl-2'>
                <p className='heading-12-inter-medium'>
                  Your request has been received successfully Ticket ID: #{supportSuccess.ticketCode}.{" "}
                  Our support team will review your request and respond within 24–48 hours.
                </p>
                <div>
                </div>
                <p>You’ll receive updates here and on registered email.
                  <button type="button" onClick={() => { openViewProfileModal?.(null); openViewProfileModal?.("supporttrack") }} className="text-sm underline pl-1"> Track request </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* grid grid-cols-2 gap-x-2 p-1 */}
      <>
        {HeaderBox()}
      </>
      <>
        {BoxUiUserDetails()}
      </>
      <div className="form-container">
        {/* <Input id={"name"} label={"First name"} error={error?.fname} name={"fname"} value={profileState.fname} type="text" onChange={handleChange} isRequired={true} disabled={true}  />     
    <Input id={"name"} label={"Last name"} name={"lname"} error={error.lname} value={profileState.lname} type="text" onChange={handleChange} isRequired={true} disabled={true}  />    
    <Input id={"email"} label={"User email"} name={"email"} error={error.lname} value={profileState.email} type="text" onChange={handleChange} isRequired={true} disabled={true}  />  */}
        {/* <Input id={"mobile"} label={"Mobile"} name={"mobile"} value={profileState.mobile??""} type="text" onChange={handleChange} isRequired={true} disabled={true}  />      */}
        {/* <div className={`main-box1 group`} >
          <label htmlFor={"mobile"} className={`label-box1`}>Mobile<span className="text-rose-400 text-lg pl-0.5">*</span></label>
          <PhoneInput  forceDialCode={true} hideDropdown={true} disabled={true}  inputProps={{name: 'mobile' ,onPaste: (e) => {e.preventDefault()} ,required: true,autoComplete: 'off',className:"mobile-disable cursor-not-allowed text-[#999999]"}} defaultCountry="in" name="mobile" value={profileState?.mobile??""}
          className={`signupmobile w-full`} />
          {error.mobile && <span className={`helper-box1 opacity-100 ${error.mobile ? "text-rose-400" : ""}`}>{error.message}</span>}
        </div> */}
        {/* <Input id={"subject"} label={"Subject"} error={error.subject} name={"subject"} value={profileState.subject} type="text" onChange={handleChange} isRequired={true}  />      */}
        {/* <Input id={"units"} label={"Units"} name={"units"} value={"M"} type="text" onChange={handleChange} isRequired={true} disabled={isEditing}  />      */}
      </div>
      <div className='w-[100%] p-1 pt-2 pb-3 mb-1'>
        <ReactSelect isSearchable={false} isrequired onChange={handleChange} noOptionsMessage="No options" options={supportSubjectList.map((item) => ({ label: item.subject_title, value: item.subjectid }))} value={profileState.subject} closeMenuOnSelect={true} key="subject" labelname="What can we help you with?" placeholder="Select request topic .." name="subject" error={error.subject} menuPlacement='bottom' />
        <GTextareaCom max='1000 words' maxLength={1000} helpertext={` ${profileState?.message?.length || 0} / 1000 `} error={error.message} placeholder='Briefly describe your issue. Include location, installation stage, or error message if any.' id={"message"} label={"Message"} name={"message"} value={profileState.message} type="text" onChange={handleChange} isRequired={true} />
        {true && (
          <div className='mt-6'>
            <NewFileUpload maxSize={60} name="uploadFile" label='Attachments' btnLabel={'Select file'} acceptType={".jpg,.jpeg,.png,.pdf,.mp4"} filenames={uploadFileNames || []} isSingle={true} disable={false} isrequired={isUploadRequired}
              error={isUploadRequired ? error?.uploadFile : undefined} onFileChange={(_name, files) => { setUploadFileNames?.(files); if (files.length > 0) { clearError?.("uploadFile"); } }}
              handlePreviewClick={handlePreviewClick} helpertext='Upload bill, inverter photo, roof photo, or error screenshot for faster support.' />
          </div>
        )}
      </div>
    </>
  )
}

export default memo(Support)


